__turbopack_context__.v({
  "animate": "staranimation-module-scss-module__kXfJJq__animate",
  "bigStar": "staranimation-module-scss-module__kXfJJq__bigStar",
  "star": "staranimation-module-scss-module__kXfJJq__star",
});
